import { useMutation } from '@tanstack/react-query';
import { api } from '../services/api';

/**
 * Mutation to regenerate a post
 * @param {function} onSuccess - Callback when post regeneration succeeds
 * @param {function} onError - Callback when post regeneration fails
 */
export const useRegeneratePost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, userInput }) => {
      const result = await api.regeneratePost(postId, userInput);
      if (result?.error) {
        throw new Error(result.message || 'Failed to regenerate post');
      }
      return result;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Post regeneration error:', error);
      if (onError) onError(error);
    },
  });
};

// Update post mutation: wraps api.updatePost and allows external success/error callbacks
export const useUpdatePost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, data }) => {
      return api.updatePost(postId, data);
    },
    onSuccess,
    onError,
  });
};
